import { IAutomaticallyBySetRules } from 'app/library/module/interfaces/automatically-by-set-rules.interface';
import { CompletionRule } from '../enums/completion-rule.enum';

// @dynamic
export class CourseCompletionRuleOptions {
    static all: IAutomaticallyBySetRules[] = [
        {
            translationLabel: 'COURSES.COMPLETION_RULE.BY_END_DATE',
            value: CompletionRule.AUTO_END_DATE_REACHED,
            isSelected: false,
        },
        {
            translationLabel: 'COURSES.COMPLETION_RULE.BY_SECTIONS',
            value: CompletionRule.SECTIONS,
            isSelected: false,
        },
        {
            translationLabel: 'COURSES.COMPLETION_RULE.BY_MIN_ATTENDANCE',
            value: CompletionRule.AUTO_MIN_ATTENDANCE_REACHED,
            isSelected: false,
        },
        {
            translationLabel: 'COURSES.COMPLETION_RULE.BY_CERTIFICATE',
            value: CompletionRule.AUTO_RECEIVE_CERTIFICATE,
            isSelected: false,
        },
        {
            translationLabel: 'COURSES.COMPLETION_RULE.BY_PASSING_GRADE',
            value: CompletionRule.AUTO_ACHIEVE_PASSING_GRADE,
            isSelected: false,
        },
    ];

    static forELearning: IAutomaticallyBySetRules[] = [
        {
            translationLabel: 'COURSES.COMPLETION_RULE.BY_SECTIONS',
            value: CompletionRule.SECTIONS,
            isSelected: false,
        },
        {
            translationLabel: 'COURSES.COMPLETION_RULE.BY_CERTIFICATE',
            value: CompletionRule.AUTO_RECEIVE_CERTIFICATE,
            isSelected: false,
        },
        {
            translationLabel: 'COURSES.COMPLETION_RULE.BY_PASSING_GRADE',
            value: CompletionRule.AUTO_ACHIEVE_PASSING_GRADE,
            isSelected: false,
        },
    ];
}
